import ApiService from '../../services/api.service';
import { CompanyService } from './../../services/company.service';

export const postNuevaEmpresa = async ({ commit }, payload) => {
  commit('user/initRequest', null, { root: true });
  let status = true;
  const url = ApiService.getEndpoint('/empresa/registro');
  try {
    commit('user/fetchRequest', true, { root: true });
    await ApiService.post(url, payload);
  } catch (err) {
    commit(
      'user/setError',
      {
        isError: true,
        errorMessage: err.response ? err.response.data.message : err.message
      },
      { root: true }
    );
    status = false;
  } finally {
    commit('user/finishRequest', false, { root: true });
  }
  return status;
};

export const postNuevoUsuarioEmpresa = async ({ commit }, payload) => {
  commit('user/initRequest', null, { root: true });
  let status = true;
  const url = ApiService.getEndpoint('/empresa/usuarioEmpresa/registro');
  try {
    commit('user/fetchRequest', true, { root: true });
    await ApiService.post(url, payload);
  } catch (err) {
    commit(
      'user/setError',
      {
        isError: true,
        errorMessage: err.response ? err.response.data.message : err.message
      },
      { root: true }
    );
    status = false;
  } finally {
    commit('user/finishRequest', false, { root: true });
  }
  return status;
};

export const getVerificarRuc = async ({ commit }, ruc) => {
  commit('user/initRequest', null, { root: true });
  const url = ApiService.getEndpoint('/ref-data/empresa/' + ruc);

  try {
    commit('user/fetchRequest', true, { root: true });
    let response = await ApiService.get(url);
    return response.data.data;
  } catch (err) {
    console.log(err.response);
    commit(
      'user/setError',
      {
        isError: true,
        errorMessage: err.response ? err.response.data.message : err.message
      },
      { root: true }
    );
    return false;
  } finally {
    commit('user/finishRequest', null, { root: true });
  }
};

export const fetchPerfilEmpresa = async ({ commit }) => {
  commit('user/initRequest', null, { root: true });
  const url = ApiService.getEndpoint('/empresa/obtener');
  try {
    commit('user/fetchRequest', true, { root: true });
    let response = await ApiService.get(url);
    commit('setPerfil', response.data.data);
  } catch (err) {
    console.log(err.response);
    commit(
      'user/setError',
      {
        isError: true,
        errorMessage: err.response ? err.response.data.message : err.message
      },
      { root: true }
    );
    return false;
  } finally {
    commit('user/finishRequest', null, { root: true });
  }
};

export const fetchListaTrabajos = async ({ commit }) => {
  commit('user/initRequest', null, { root: true });
  const url = ApiService.getEndpoint('/empresa/trabajo/listar');
  try {
    commit('user/fetchRequest', true, { root: true });
    let response = await ApiService.get(url);
    commit('setListaTrabajos', response.data.data);
  } catch (err) {
    console.log(err.response);
    commit(
      'user/setError',
      {
        isError: true,
        errorMessage: err.response ? err.response.data.message : err.message
      },
      { root: true }
    );
    return false;
  } finally {
    commit('user/finishRequest', null, { root: true });
  }
};

export const crearTrabajo = async ({ commit }, payload) => {
  commit('user/initRequest', null, { root: true });
  try {
    commit('user/fetchRequest', true, { root: true });
    let response = await CompanyService.createJob(payload);
    return response;
  } catch (err) {
    commit(
      'user/setError',
      {
        isError: true,
        errorMessage: err.response ? err.response.data.message : err.message
      },
      { root: true }
    );
    return err.response.data.success;
  } finally {
    commit('user/finishRequest', null, { root: true });
  }
};

export const fetchProvincia = async ({ commit }, codigo) => {
  commit('user/initRequest', null, { root: true });
  let url = ApiService.getEndpoint('/ref-data/provincia/' + codigo);
  try {
    commit('user/fetchRequest', true, { root: true });
    let response = await ApiService.get(url);
    return response.data.data;
  } catch (err) {
    commit(
      'user/setError',
      {
        isError: true,
        errorMessage: err.response ? err.response.data.message : err.message
      },
      { root: true }
    );
    return err.response.data.success;
  } finally {
    commit('user/finishRequest', null, { root: true });
  }
};

export const fetchDistritos = async ({ commit }, codigo) => {
  commit('user/initRequest', null, { root: true });
  let url = ApiService.getEndpoint('/ref-data/distrito/' + codigo);
  try {
    commit('user/fetchRequest', true, { root: true });
    let response = await ApiService.get(url);
    return response.data.data;
  } catch (err) {
    commit(
      'user/setError',
      {
        isError: true,
        errorMessage: err.response ? err.response.data.message : err.message
      },
      { root: true }
    );
    return err.response.data.success;
  } finally {
    commit('user/finishRequest', null, { root: true });
  }
};

export const uploadPhotoCompany = async ({ commit }, photo) => {
  commit('user/initRequest', null, { root: true });
  try {
    commit('user/fetchRequest', true, { root: true });
    let response = await CompanyService.uploadPhoto(photo);
    console.log(response);
    return response;
  } catch (err) {
    commit(
      'user/setError',
      {
        isError: true,
        errorMessage: err.response ? err.response.data.message : err.message
      },
      { root: true }
    );
    return err.response.data.success;
  } finally {
    commit('user/finishRequest', null, { root: true });
  }
};

export const fetchIndustrias = async ({ commit }) => {
  commit('user/initRequest', null, { root: true });
  let url = ApiService.getEndpoint('/ref-data/industrias');
  try {
    commit('user/fetchRequest', true, { root: true });
    let response = await ApiService.get(url);
    return response.data.data;
  } catch (err) {
    commit(
      'user/setError',
      {
        isError: true,
        errorMessage: err.response ? err.response.data.message : err.message
      },
      { root: true }
    );
    return err.response.data.success;
  } finally {
    commit('user/finishRequest', null, { root: true });
  }
};

export const fetchCambiarEstadoPropuesta = async ({ commit }, body) => {
  commit('user/initRequest', null, { root: true });
  let result = false;
  const url = ApiService.getEndpoint('/empresa/trabajo/status');
  try {
    commit('user/fetchRequest', true, { root: true });
    let response = await ApiService.post(url, body);
    if (response) {
      commit(
        'user/setSuccess',
        {
          isSuccess: true,
          successMessage: 'Cambio realizado exitosamente'
        },
        { root: true }
      );
    }
    result = true;
  } catch (err) {
    commit(
      'user/setError',
      {
        isError: true,
        errorMessage: err.response ? err.response.data.message : err.message
      },
      { root: true }
    );
    result = false;
  } finally {
    commit('user/finishRequest', null, { root: true });
  }
  return result;
};
